DJ.addBehavior('breadcrumb-mobile', '.breadcrumbs', {
  attach: function(context, settings, behavior) {
    var $breadcrumbs = jQuery(this);
    var $list = $breadcrumbs.find('.breadcrumbs-list');
    var $toggle = $breadcrumbs.find('.breadcrumbs-toggle');
    var $wrapper = $toggle.closest('.breadcrumbs-mobile-wrapper');
    var $panel = $breadcrumbs.find('.breadcrumbs-panel');
    var $items = $list.find('li');
    var itemCount = $items.length;

    // Masquer temporairement le panneau au chargement pour éviter le flash
    // d'affichage avant que le JS ne prenne la main. La classe est retirée
    // automatiquement après une demi-seconde (et on re-mesure une fois les
    // polices chargées).
    setTimeout(function() {
      $breadcrumbs.removeClass('breadcrumbs--initial-hidden');
      initBreadcrumbPanel();
    }, 500);

    // Le fil d'Ariane complet tient-il sur une seule ligne ?
    // On mesure la largeur naturelle de la liste (items en `nowrap`,
    // `flex-shrink: 0`) par rapport à l'espace disponible, sans tenir compte
    // du viewport : le collapse s'active dès que ça déborde, quelle que soit
    // la taille d'écran (BIOGAFRREP-489).
    function fitsOnOneLine() {
      var el = $list[0];
      if (!el) {
        return true;
      }
      // La classe panel-active masque la liste (display:none !important) ;
      // on la retire le temps de la mesure puis on la restaure.
      var hadActive = $breadcrumbs.hasClass('breadcrumbs-panel-active');
      if (hadActive) {
        $breadcrumbs.removeClass('breadcrumbs-panel-active');
      }
      var prevDisplay = el.style.display;
      var prevVisibility = el.style.visibility;
      el.style.visibility = 'hidden';
      el.style.display = 'flex';
      // +1px de tolérance pour absorber les arrondis sous-pixels.
      var fits = el.scrollWidth <= el.clientWidth + 1;
      el.style.display = prevDisplay;
      el.style.visibility = prevVisibility;
      if (hadActive) {
        $breadcrumbs.addClass('breadcrumbs-panel-active');
      }
      return fits;
    }

    function showFullTrail() {
      $wrapper.removeClass('show').hide();
      // Set the display explicitly: jQuery .show() would restore the <ol>
      // default (block) and break the horizontal `display: flex` layout when
      // switching back from the collapsed state.
      $list.css('display', 'flex');
      $panel.hide().removeClass('is-open').attr('aria-hidden', 'true');
      $toggle.attr('aria-expanded', 'false');
      $breadcrumbs.removeClass('breadcrumbs-panel-active');
    }

    function collapseTrail() {
      $wrapper.addClass('show').css('display', 'flex');
      $list.css('display', 'none');
      // Le panneau reste caché par défaut, il s'affiche uniquement au clic.
      $panel.hide().removeClass('is-open').attr('aria-hidden', 'true');
      $toggle.attr('aria-expanded', 'false');
      $breadcrumbs.addClass('breadcrumbs-panel-active');
    }

    // Décide d'afficher le fil complet ou la version repliée "..." selon que
    // le contenu tient (ou non) sur une ligne.
    function initBreadcrumbPanel() {
      // 1 ou 2 niveaux : toujours afficher le fil complet.
      if (itemCount <= 2) {
        showFullTrail();
        return;
      }

      if (fitsOnOneLine()) {
        showFullTrail();
      } else {
        collapseTrail();
      }
    }

    // Initialisation
    initBreadcrumbPanel();

    // Gérer le clic sur le bouton toggle
    $toggle.on('click.breadcrumb-mobile', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isExpanded = $toggle.attr('aria-expanded') === 'true';

      if (isExpanded) {
        // Fermer le panneau
        $toggle.attr('aria-expanded', 'false');
        $panel.attr('aria-hidden', 'true');
        $panel.removeClass('is-open').hide();
      } else {
        // Ouvrir le panneau
        $toggle.attr('aria-expanded', 'true');
        $panel.attr('aria-hidden', 'false');
        $panel.addClass('is-open').show();
      }
    });

    // Fermer le panneau en cliquant à l'extérieur
    var clickOutsideHandler = function(e) {
      if (!$breadcrumbs.is(e.target) && $breadcrumbs.has(e.target).length === 0) {
        if ($panel.hasClass('is-open')) {
          $toggle.attr('aria-expanded', 'false');
          $panel.attr('aria-hidden', 'true');
          $panel.removeClass('is-open').hide();
        }
      }
    };
    jQuery(document).on('click.breadcrumb-mobile', clickOutsideHandler);

    // Fermer le panneau quand on clique sur un lien
    $panel.on('click.breadcrumb-mobile', 'a', function() {
      $toggle.attr('aria-expanded', 'false');
      $panel.attr('aria-hidden', 'true');
      $panel.removeClass('is-open').hide();
    });

    // Re-vérifier au redimensionnement de la fenêtre
    var resizeTimer;
    var resizeHandler = function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initBreadcrumbPanel();
      }, 250);
    };
    jQuery(window).on('resize.breadcrumb-mobile', resizeHandler);
  },

  detach: function(context, settings) {
    var $breadcrumbs = jQuery(this);
    var $toggle = $breadcrumbs.find('.breadcrumbs-toggle');
    var $panel = $breadcrumbs.find('.breadcrumbs-panel');

    $toggle.off('click.breadcrumb-mobile');
    $panel.off('click.breadcrumb-mobile');
    jQuery(document).off('click.breadcrumb-mobile');
    jQuery(window).off('resize.breadcrumb-mobile');
  }
});
